import { render, staticRenderFns } from "./modal-detail-product2.vue?vue&type=template&id=03494cc8"
import script from "./modal-detail-product2.vue?vue&type=script&lang=js"
export * from "./modal-detail-product2.vue?vue&type=script&lang=js"
import style0 from "./modal-detail-product2.vue?vue&type=style&index=0&id=03494cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports